module.exports = __webpack_public_path__ + "static/media/wall-grey.18de2295.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/wall-grey.png
// module id = 143
// module chunks = 0